import { Alert, type AlertProps, Box, type BoxProps, Typography } from "@mui/material";
import { ErrorBoundary } from "@navigations/ErrorBoundary";
import { type ILoadingProps, Loading } from "@surfaces/Loading";
import { type ReactNode, Suspense } from "react";

export interface ISuspenseHandlerProps {
  children: ReactNode | ReactNode[];
  slotProps?: {
    alert?: Partial<AlertProps>;
    loading?: Partial<ILoadingProps>;
    box?: Partial<BoxProps>;
  };
  redirect?: string;
}

export const SuspenseHandler = ({ redirect, children, slotProps }: ISuspenseHandlerProps) => {
  return (
    <ErrorBoundary
      redirect={redirect}
      fallback={
        <Alert severity="error" {...slotProps?.alert}>
          <Typography variant="body1SemiBold">Oops !</Typography>
          <Typography variant="body1">Une erreur inattendue est survenue</Typography>
        </Alert>
      }
    >
      <Suspense
        fallback={
          <Box
            {...slotProps?.box}
            sx={{
              position: "relative",
            }}
          >
            <Loading {...slotProps?.loading} loading />
          </Box>
        }
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};
